// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rigth-content_wrapper__3HyAv","listSectionMobile":"rigth-content_listSectionMobile__A46Ti","listSection":"rigth-content_listSection__pneT4"};